import { TextField } from '@mui/material';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { translate } from 'utils';

import { isValidPhoneNumber } from 'libphonenumber-js';
import { StorageHelper } from 'utils/helpers';
import { buildDefaultAndTraineeAnswers, QUESTION_TYPES_FROM_API } from '../../QuizHelper';

const PhoneQuestion = observer(({ currentQuestionData, isReadOnlyQuestion }) => {
  const { phoneInput } = QUESTION_TYPES_FROM_API;

  const { examinationStore } = useStores();

  const { currentPage } = examinationStore;

  const [currentValue, setCurrentValue] = useState('');
  const [isValidPNumber, setIsValidPNumber] = useState(false);
  const [error, setError] = useState('');

  const buildAnswers = useCallback(() => {
    setCurrentValue(buildDefaultAndTraineeAnswers(currentQuestionData));
  }, [currentQuestionData]);

  useEffect(() => {
    buildAnswers();
  }, [buildAnswers]);

  const handleChangeAnswer = useCallback(event => {
    const { value } = event.target;

    const currentLanguage = StorageHelper.GET('i18nextLng').toUpperCase();

    setIsValidPNumber(isValidPhoneNumber(value, currentLanguage));
    isValidPhoneNumber(value, currentLanguage) ? setError('') : setError(translate('errors.phoneNumberError'));
    setCurrentValue(value);

    examinationStore.toggleQuestionValidity({ questionType: phoneInput, status: isValidPhoneNumber(value, currentLanguage) });
    examinationStore.setTraineeAnswers(currentPage, currentQuestionData, value);
  }, [currentPage, currentQuestionData, examinationStore, phoneInput]);

  return (
    <>
      <TextField
        autoComplete="off"
        disabled={isReadOnlyQuestion}
        error={!isValidPNumber && error.length > 0}
        fullWidth
        helperText={error}
        name="textAnswer"
        placeholder={translate('common.writePhoneNumber')}
        required
        style={{ margin: '10px 0px' }}
        value={currentValue}
        variant="outlined"
        onChange={handleChangeAnswer}
      />
    </>
  );
});

export default PhoneQuestion;

PhoneQuestion.propTypes = {
  currentQuestionData: PropTypes.shape({}),
  withCorrection: PropTypes.bool.isRequired,
  isReadOnlyQuestion: PropTypes.bool.isRequired
};

PhoneQuestion.defaultProps = {
  currentQuestionData: {}
};
